<div class="toolbar row">
  <div class="col-md-6">
    <div class="btn-group">
      <button mat-raised-button class="button" (click)="addFolder()" style="border-radius: 6px; margin: 0px 2px 0px 2px" pTooltip="Add Folder">
        <i class="fa fa-plus"></i>
        <i class="fa fa-folder-o" style="margin-left: 5px;"></i>
      </button>
      <span class="hidden-input-file">
        <input #fileInput type="file" ng2FileSelect [uploader]="fileManagerUploader.uploader" multiple/>
      </span>
      <button mat-raised-button class="button" (click)="fileInput.click()" style="border-radius: 6px; margin: 0px 2px 0px 2px" pTooltip="Add File(s)">
        <i class="fa fa-plus"></i>
        <i class="fa fa-file-o" style="margin-left: 5px;"></i>
      </button>
      <ri-selection-dropdown (onMenuButtonClick)="onMenuButtonClick.next($event)"></ri-selection-dropdown>
      <button mat-raised-button class="button" (click)="onRefreshFilesList()"
              style="border-radius: 6px;margin: 0px 2px 0px 2px" pTooltip="Refresh">
        <i class="fa fa-refresh"></i>
      </button>
      <button mat-raised-button class="button" (click)="onDownloadZip()"
              style="border-radius: 6px;margin: 0px 2px 0px 2px" pTooltip="Download as Zip">
        <i class="fa fa-file-zip-o"></i>
      </button>
      <mat-button-toggle-group style="margin-left: 50px; height: 36px;" #group="matButtonToggleGroup" [value]="'1'"
                               (change)="modeChange(group.value)">
        <mat-button-toggle [value]="'1'" style="width: 50%;">
          List
        </mat-button-toggle>
        <mat-button-toggle [value]="'0'" style="width: 50%;line-height: 34px;height:34px">
          Icons
        </mat-button-toggle>
      </mat-button-toggle-group>
      <ri-search-file style="float:left;"></ri-search-file>
      <!--ri-file-type-filter [typeFilterList]="configuration.fileTypesFilter"></ri-file-type-filter-->
    </div>
  </div>
</div>
